import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/editCambioEstado`, method: 'POST', body: values, token: token})
}
